// extracted by mini-css-extract-plugin
var _1 = "BBTGvlIN";
var _2 = "qpFG7oI3";
var _3 = "cF80_c4g";
var _4 = "SGnZvKrn";
var _5 = "i16FTVqs";
export { _1 as "key", _2 as "keyActive", _3 as "keyBlocked", _4 as "keyDown", _5 as "keyUp" }
